import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {DIAGRAM_VERSION_STATES_ENUM} from '../models/diagram-version.constant';

@Pipe({
  name: 'versionName',
  standalone: true
})
export class VersionNamePipe implements PipeTransform {
  private ready = this.translateSvc.instant('VERSIONING.DIAGRAM_STATE_READY');
  private master = this.translateSvc.instant('ASIDE_R.VERSION');
  private archive = this.translateSvc.instant('ASIDE_R.VERSION');
  private neverPublished = this.translateSvc.instant('VERSIONING.DIAGRAM_STATE_NEVER_PUBLISHED');
  private beingAuthorised = this.translateSvc.instant('VERSIONING.BEING_AUTHORISED_DIAGRAM_LABEL');
  private cancelled = this.translateSvc.instant('Cancelled');

  constructor(private translateSvc: TranslateService) {}

  transform(version): string {
    if (version) {
      switch (version.state) {
        case DIAGRAM_VERSION_STATES_ENUM.READY:
          return this.ready;

        case DIAGRAM_VERSION_STATES_ENUM.BEING_AUTHORISED:
          return this.beingAuthorised;

        case DIAGRAM_VERSION_STATES_ENUM.CANCELLED:
          return this.cancelled;

        case DIAGRAM_VERSION_STATES_ENUM.MASTER:
          return this.master + ' ' + version.version;

        case DIAGRAM_VERSION_STATES_ENUM.ARCHIVE:
          return this.archive + ' ' + version.version;

        case DIAGRAM_VERSION_STATES_ENUM.NEVER_PUBLISHED:
          return this.neverPublished;
      }
    } else {
      return '';
    }
  }
}
